export default __webpack_public_path__ + "static/media/SCTeam_Field.4fccdc9a.png";